import { ListInput, Icon } from "framework7-react";
import { formatAmountInput } from "../../utils/format";
import { parseCents } from "../../utils/money";

const MoneyInput = ({ value = 0, onChange, label = "Betrag", ...props }) => {
  const handleChange = (e) => {
    onChange?.(parseCents(e.target.value));
  };

  return (
    <ListInput
      floatingLabel
      outline
      type="text"
      name="amount"
      autocomplete="off"
      // ListInput only forwards the lowercase spelling.
      inputmode="numeric"
      label={label}
      value={formatAmountInput(value)}
      onChange={handleChange}
      {...props}
    >
      <Icon
        className="money-input-currency"
        md="material:euro"
        ios="f7:money_euro"
        slot="content-end"
        size={18}
      />
    </ListInput>
  );
};

// F7's <List> only renders children named f7-list-input* inside its <ul>.
MoneyInput.displayName = "f7-list-input-money";

export default MoneyInput;
